// (c) Copyright 2025 Hewlett Packard Enterprise Development LP

import { useRoutes } from "react-router-dom"
import { routes } from "../shell-routes.js"
import { getMfeBaseUrlPath, isShellMfe } from "../utils/env.js"
// import { ShellRoute } from "../routes/shell-route.js"
// import { DSCCHeader } from "../components"
// import { Launchpad } from "../routes/launchpad.js"

export function usePrefixedRoutes(rawRoutes) {
  const mfePrefix = getMfeBaseUrlPath()
  // assume rawRoutes is an array of route objects for useRoutes()
  const scopedRoutes = rawRoutes.map((route) => {
    const { path, ...rest } = route
    const matchedRoute = Object.values(routes).find(
      ({ path }) => path === route.path
    )
    if (matchedRoute?.isMfe && isShellMfe) {
      const newPath = `${mfePrefix}${path}`
      console.log(`  mapping route "${path}" → "${newPath}"`)
      return { path: newPath, ...rest }
    }
    return route
  })
  return useRoutes([
    ...scopedRoutes,
    // Add the launchpad route with the MFE prefix for backwards compatibility
    // {
    //   path: `${mfePrefix}${routes.launchpad.path}`,
    //   element: (
    //     <ShellRoute Header={DSCCHeader}>
    //       <Launchpad />
    //     </ShellRoute>
    //   ),
    // },
  ])
}
